import { Button, Popover, Tooltip } from 'antd';
import { useBreakpoint } from '@/shared/lib/hooks';
import { groupArchiveBlockReason } from '../model/groupArchive';
import { useGroupArchive } from '../model/useGroupArchive';
import type { CategoryDto } from '../model/types';

export interface GroupArchiveButtonProps {
  group: Pick<CategoryDto, 'id' | 'name' | 'parentId' | 'isArchived'>;
  /** Весь список категорий (с архивными или без): по нему считаются живые подкатегории группы. */
  categories: Pick<CategoryDto, 'parentId' | 'isArchived'>[];
  /** После успешной отправки в архив (например, закрыть окно группы). */
  onArchived?: () => void;
  size?: 'small' | 'middle';
}

/** §2.1: «Удалить» корневую группу = «В архив». Для группы с неархивными подкатегориями кнопка
 *  недоступна, а подсказка объясняет почему; архивную группу можно вернуть. */
export function GroupArchiveButton({ group, categories, onArchived, size = 'small' }: GroupArchiveButtonProps) {
  const { archiveGroup, restoreGroup } = useGroupArchive();
  const { isMobile } = useBreakpoint();

  if (group.isArchived) {
    return (
      <Button size={size} onClick={() => void restoreGroup(group)}>
        Вернуть из архива
      </Button>
    );
  }

  const reason = groupArchiveBlockReason(group, categories);
  const button = (
    <Button size={size} disabled={reason !== null} onClick={() => archiveGroup(group, onArchived)}>
      В архив
    </Button>
  );
  // На телефоне нет наведения: причину, почему «В архив» недоступна, показываем по касанию. Отключённая
  // кнопка касаний не получает — ловит их обёртка, а сама кнопка пропускает касание сквозь себя.
  if (isMobile && reason !== null) {
    return (
      <Popover trigger="click" content={reason} styles={{ root: { maxWidth: 'calc(100vw - 32px)' } }}>
        <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
          <Button size={size} disabled style={{ pointerEvents: 'none' }}>
            В архив
          </Button>
        </span>
      </Popover>
    );
  }
  return <Tooltip title={reason}>{button}</Tooltip>;
}
